module.exports = __webpack_public_path__ + "img/zhongcha_logo.99c57b54.png";